import React, { useEffect, useState } from "react";
import ProductCard from "../components/ProductCard";
import SkeletonProductCard from "./../loaders/SkeletonProductCard"; // Import Skeleton
import Pagination from "../components/Pagination";
import axiosInstance from "../config/axiosInstance";
import { showToast, ToastNotification } from "./ToastNotification";
import { API_ENDPOINTS } from "../config/apiConfig";

const ProductList = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const loadProducts = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get(
                    `${API_ENDPOINTS.PRODUCTLIST}?pageNumber=${pageNumber}&pageSize=100&sortBy=name&sortDir=asc`
                );

                setProducts(response.data.content);
                setTotalPages(response.data.totalPages);

            } catch (error) {
                const errorMessage = error.response?.data?.message || "Loading failed to fetch the products. Please try again.";
                showToast(errorMessage, "error");
                setError(errorMessage);
            }
            setLoading(false);
        };

        loadProducts();
    }, [pageNumber]);

    return (
        <div className="container mt-4">
            <ToastNotification />
            {error ? (
                <p className="text-danger">{error}</p>
            ) : (
                <>
                    <div className="row g-3">
                        {loading ? (
                            // ✅ Skeleton Loader
                            Array.from({ length: 8 }).map((_, index) => (
                                <div key={index} className="col-6 col-sm-6 col-md-4 col-lg-3">
                                    <SkeletonProductCard />
                                </div>
                            ))
                        ) : products.length === 0 ? (
                            // ✅ No Products Message
                            <div className="text-center w-100">
                                <h4>No products available</h4>
                            </div>
                        ) : (
                            // ✅ Render Products
                            products.map((product) => (
                                <div key={product.id} className="col-6 col-sm-6 col-md-4 col-lg-3">
                                    <ProductCard product={product} />
                                </div>
                            ))
                        )}
                    </div>

                    {/* ✅ Pagination सिर्फ तब दिखाएं जब प्रोडक्ट्स हों */}
                    {!loading && products.length > 0 && (
                        <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber} />
                    )}
                </>
            )}
        </div>
    );
};

export default ProductList;
